import { applyMiddleware, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";

import rootReducer from "../reducers";
import rootSaga from "../sagas";

const persistConfig = {
  storage,
  key: "root",
  whitelist: ["language", "userInterface"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const configureStore = (initialState = {}) => {
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [thunk, sagaMiddleware];
  const enhancers = [applyMiddleware(...middleware)];
  const store = createStore(persistedReducer, initialState, ...enhancers);
  const persistor = persistStore(store);

  sagaMiddleware.run(rootSaga);
  // store.close = () => store.dispatch(END);

  return { store, persistor };
};

export default configureStore;
export type RootStateDesktop = ReturnType<typeof rootReducer>;
